import React from 'react';
import { motion } from 'framer-motion';

const ValueProposition = () => {
  const benefits = [
    {
      title: "FULL CONTEXT AWARENESS",
      desc: "Traditional scanners look at files in isolation. PassiveGuard builds a complete dependency graph of your application, understanding how data flows between components to find complex vulnerabilities.",
      icon: "🧠"
    },
    {
      title: "ZERO-LATENCY INTEGRATION",
      desc: "Don't wait for CI/CD pipelines to fail. Our passive scanning technology runs in the background as you code, providing instant feedback without slowing down your development workflow.",
      icon: "⚡"
    },
    {
      title: "PROACTIVE DEFENSE",
      desc: "Stop reacting to breaches. By identifying infrastructure misconfigurations and supply chain risks before deployment, you eliminate attack vectors before they can be exploited.",
      icon: "🛡️"
    }
  ];

  return (
    <div className="value-prop-container">
      <div className="value-prop-header">
        <h2 className="section-title center">WHY PASSIVEGUARD?</h2>
        <p className="section-subtitle">The bridge between static analysis and real-world security.</p>
      </div>

      <div className="benefits-grid">
        {benefits.map((benefit, index) => (
          <motion.div 
            className="benefit-card"
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <div className="benefit-icon">{benefit.icon}</div>
            <h3 className="benefit-title">{benefit.title}</h3>
            <p className="benefit-desc">{benefit.desc}</p>
          </motion.div>
        ))}
      </div>

      <motion.div 
        className="comparison-table-container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        viewport={{ once: true }}
        style={{ marginTop: '5rem' }}
      >
        <h3 className="section-subtitle center" style={{ marginBottom: '2rem' }}>HOW WE COMPARE</h3>
        <table className="why-us-table">
          <thead>
            <tr>
              <th>FEATURE</th>
              <th className="legacy-col">LEGACY SCANNERS (Qualys/Nessus)</th>
              <th className="pg-col">OUR SCANNER</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="feature-cell">Setup Time</td>
              <td className="legacy-cell">Days (Complex Agents)</td>
              <td className="pg-cell">&lt; 2 Minutes</td>
            </tr>
            <tr>
              <td className="feature-cell">Signal-to-Noise</td>
              <td className="legacy-cell">High (Many False Positives)</td>
              <td className="pg-cell">AI-Verified Results</td>
            </tr>
            <tr>
              <td className="feature-cell">Impact on Production</td>
              <td className="legacy-cell">Active Probing (Risk of Downtime)</td>
              <td className="pg-cell">Zero Impact (Passive Analysis)</td>
            </tr>
            <tr>
              <td className="feature-cell">Data Privacy</td>
              <td className="legacy-cell">Data Uploaded to Cloud</td>
              <td className="pg-cell">Local Scanning (Data Stays with You)</td>
            </tr>
            <tr>
              <td className="feature-cell">Modern Tech Support</td>
              <td className="legacy-cell">Slow to Adapt (Monolithic)</td>
              <td className="pg-cell">Cloud-Native (K8s, Terraform, API-First)</td>
            </tr>
            <tr>
              <td className="feature-cell">Pricing</td>
              <td className="legacy-cell">Per-Asset (Expensive Scale)</td>
              <td className="pg-cell">Transparent, Predictable</td>
            </tr>
            <tr>
              <td className="feature-cell">Dev Experience</td>
              <td className="legacy-cell">PDF Reports</td>
              <td className="pg-cell">Direct GitHub/GitLab Integration</td>
            </tr>
          </tbody>
        </table>
      </motion.div>
    </div>
  );
};

export default ValueProposition;
